import { render, staticRenderFns } from "./BlockSettings.vue?vue&type=template&id=46251477"
import script from "./BlockSettings.vue?vue&type=script&lang=js"
export * from "./BlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports